export default __webpack_public_path__ + "static/media/segre11.9789354f.jpg";